module.exports = __webpack_public_path__ + "static/media/reactlogo.58362448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reactlogo.png
// module id = 149
// module chunks = 0